var _ellipse, _path, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMagicCircleIcon = function SvgMagicCircleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.463,
    cy: 9.778,
    fill: "#5B00A3",
    rx: 5.463,
    ry: 5.778
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m9.466 5.445.92 2.995h2.977l-2.409 1.85.92 2.994-2.408-1.85-2.408 1.85.92-2.994L5.57 8.44h2.976z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "magic-circle-icon_svg__a",
    width: 19,
    height: 19,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#magic-circle-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7200CC",
    d: "M-.654-1.311h20.219v21.738H-.654z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.42 12.614 3.384-1.345c.218-.087.218-.418 0-.505L13.42 9.42a1.38 1.38 0 0 1-.781-.84l-1.251-3.64a.244.244 0 0 0-.47 0l-1.25 3.64c-.134.389-.42.696-.782.84l-3.386 1.345c-.217.087-.217.418 0 .505l3.385 1.345c.362.143.648.45.782.84l1.251 3.64c.08.233.389.233.469 0l1.251-3.64c.134-.39.42-.697.782-.84M5.522 8.032l1.693-.68c.108-.044.108-.212 0-.255l-1.693-.68a.7.7 0 0 1-.39-.425l-.626-1.84a.122.122 0 0 0-.235 0l-.625 1.84a.7.7 0 0 1-.391.424l-1.693.68c-.109.044-.109.212 0 .255l1.693.68a.7.7 0 0 1 .39.425l.626 1.84c.04.119.194.119.235 0l.625-1.84a.7.7 0 0 1 .39-.424zM8.531 3.933l1.065-.424c.069-.027.069-.131 0-.158l-1.065-.423a.43.43 0 0 1-.246-.265l-.393-1.145a.077.077 0 0 0-.148 0l-.393 1.145a.43.43 0 0 1-.246.264l-1.065.424c-.069.027-.069.131 0 .158l1.065.424a.43.43 0 0 1 .245.264l.394 1.145a.077.077 0 0 0 .148 0l.393-1.145a.43.43 0 0 1 .246-.264"
  }))));
};
export { SvgMagicCircleIcon as ReactComponent };
export default "/_next/static/media/src/components/CreateNewCustomerDrawer/assets/magic-circle-icon.b8b43bb3cbe888b61ffdd452b6606385.svg";